var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.052,
    height: 12.57,
    viewBox: "0 0 22.052 12.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate",
    transform: "translate(22.052 109.71) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10027",
    "data-name": "Path 10027",
    d: "M11.026,109.711a1.54,1.54,0,0,1-1.092-.452L.453,99.777a1.544,1.544,0,1,1,2.184-2.184l8.389,8.39,8.39-8.39A1.544,1.544,0,1,1,21.6,99.777l-9.482,9.482A1.54,1.54,0,0,1,11.026,109.711Z",
    transform: "translate(0)",
    fill: "#fbb516"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevron);
export default __webpack_public_path__ + "static/media/icon-chevron.323e658d15662eeca509762772f9d6ad.svg";
export { ForwardRef as ReactComponent };